import { render, staticRenderFns } from "./CorporateDetails.vue?vue&type=template&id=63e73a38"
import script from "./CorporateDetails.vue?vue&type=script&lang=js"
export * from "./CorporateDetails.vue?vue&type=script&lang=js"
import style0 from "./CorporateDetails.vue?vue&type=style&index=0&id=63e73a38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports